'use client';
import { v4 as uuid } from 'uuid';
import { useClientOnlyConstant } from './useClientOnlyConstant';

/**
 * Generates a stable, client-only id for tagging a shopping-finished event, deferring the
 * non-deterministic `uuid()` call until the browser render per `useClientOnlyConstant`.
 */
export function useShoppingFinishedId(): string {
  return useClientOnlyConstant(() => uuid().replace(/-/g, ''), '');
}
